import { Avatar, AvatarProps } from '@fold-dev/core'
import { useEffect, useMemo, useState } from 'react'
import { FRONTEER_HEARTBEATS } from '../../App'

export const PresenceAvatar = (props: AvatarProps & any) => {
    const { userId, noPresence, ...rest } = props
    const [presence, setPresence] = useState(undefined)
    const key = useMemo(() => btoa(props.src || props.name || '123'), [props.src, props.name])

    const handleInterval = () => {
        const userTime = window[FRONTEER_HEARTBEATS][userId]
        const now = new Date().getTime()

        if (!userTime) {
            setPresence(undefined)
        } else {
            if (now - userTime < 5000) setPresence('online')
            if (now - userTime > 5000) setPresence('away')
            if (now - userTime > 10000) setPresence(undefined)
        }
    }

    useEffect(() => {
        handleInterval()
    }, [])

    useEffect(() => {
        if (noPresence) return
        handleInterval()
        const interval = setInterval(handleInterval, 5000)
        return () => clearInterval(interval)
    })

    return (
        <Avatar
            {...rest}
            key={key}
            presence={noPresence ? undefined : presence}
        />
    )
}
